import {
  ACCEPTING_ORDER_ID,
  ADD_EDIT_PRODUCTS_ID,
  CAN_I_EDIT_PRODUCTS_IN_BULK_ID,
  HOW_DO_I_ADD_PRODUCTS_USING_THE_BULK_UPLOADER_ID,
  HOW_DO_I_OFFER_FOOD_AND_DRINK_SAMPLES_ID,
  BECOME_BRAND_ID,
  BRAND_POLICIES_ID,
  CANCELING_AN_ORDER_ID,
  CONTACTING_MY_RETAILER_ID,
  CONTACT_A_BRAND_ID,
  CURRENCY_SPECIFIC_PRICING_ID,
  CUSTOMIZE_MY_PRODUCT_TRANSLATIONS_ID,
  DISPUTE_A_RETAILER_COMPLAINT_ID,
  EU_DSA_ID,
  FAIRE_ACCOUNT_SECURITY_ID,
  FAIRE_COST_ID,
  FEATURE_IMAGE_GUIDELINES_ID,
  FULFILLING_SCHEDULED_ORDERS_ID,
  HOW_AM_I_NOTIFIED_NEW_ORDERS_ID,
  HOW_DO_NET_60_TERMS_WORK_ID,
  HOW_SHOULD_I_BE_SELLING_MY_FAIRE_PRODUCTS_ID,
  ISSUE_WITH_MY_ORDER_PAYOUT_ID,
  LOCATION_SHOP_LIVE_ID,
  MAKE_A_RETURN_ID,
  NAM_SELL_ON_FAIRE_ID,
  NON_NAM_SELL_ON_FAIRE_ID,
  OPEN_SIZING_ID,
  ORDER_INVOICE_ID,
  ORDER_STATUS_ID,
  PAYOUT_AUSTRALIAN_ID,
  PAYOUT_CALCULATED_ID,
  PAYOUT_CANADIAN_ID,
  PAYOUT_EUROPEAN_ID,
  PREORDERS_ID,
  APPAREL_PREORDERS_ID,
  WHAT_IS_PREPACK_ID,
  PRODUCT_ATTRIBUTES_AND_DETAILS_ID,
  REPORT_DAMAGED_MISSING_ID,
  RETAILER_WHAT_IS_FAIRE_ID,
  SETTING_UP_PAYOUT_ID,
  SHOP_PERFORMANCE_ANALYTICS_ID,
  SUBMIT_REQUEST_TO_ADD_OR_EDIT_PRODUCTS_ID,
  TAX_FORM_1099_ID,
  TROUBLESHOOTING_WITH_ADYEN_ID,
  WHAT_ARE_BRAND_TAGS_ID,
  WHAT_ARE_SOCIAL_SELLERS_ID,
  WHAT_ARE_LEAD_TIMES_ID,
  WHERE_IS_FAIRE_AVAILABLE_ID,
  WILL_YOU_LIST_ALL_PRODUCTS_ID,
  BUILDING_POSITIVE_REPUTATION_ID,
  CAN_I_INTEGRATE_WITH_SHOPIFY_ID,
  PRESTASHOP_INTEGRATION_WITH_FAIRE_ID,
  WOOCOMMERCE_INTEGRATION_WITH_FAIRE_ID,
  COVER_IMAGE_GUIDELINES_ID,
  BRAND_STORY_GUIDELINES_ID,
  HOW_OFTEN_CAN_I_UPDATE_CONTENT_ID,
  SELLING_AND_IMPORTING_PRODUCTS_INTO_EU_ID,
  HOW_DOES_SHOPIFY_PRICE_SYNC_WORK_ID,
  SOFTWARE_INTEGRATION_WITH_FAIRE_ID,
  HOW_DO_I_CLOSE_MY_SHOP_ID,
} from "@faire/help-center-utils/articleIds";
import { Article } from "@faire/help-center-utils/articles";
import { useStrictLocalization } from "@faire/web--source/common/localization";

type ArticleCategories =
  | "GettingStarted"
  | "MyOrders"
  | "ManageMyShop"
  | "Referrals"
  | "OptimizingMyPage"
  | "InvoicesAndBilling"
  | "Account"
  | "FaireDirect"
  | "FulfillingOrders"
  | "ReturnsAndRefunds"
  | "PaymentsAndInvoices"
  | "INSIDER"
  | "FAQ"
  | "FAQForProspectiveBrands"
  | "International"
  | "ContactMyRetailer"
  | "BrandTermsAndPolicies"
  | "ImportFeesAndDuties"
  | "Integration";

export type ArticlesType = {
  [key in ArticleCategories]: {
    [key: string]: Article;
  };
};

export const useArticles = () => {
  const { strictLocalize } = useStrictLocalization();
  const articles = {
    GettingStarted: {
      COMPLETING_ONBOARDING_FORM: new Article({
        name: strictLocalize({
          defaultMessage: "Completing my Onboarding Form",
          description: { text: "Title of an article" },
        }),
        id: "360039212391",
      }),
      UPLOAD_FIRST_CATALOG: new Article({
        name: strictLocalize({
          defaultMessage: "Uploading your product catalog",
          description: { text: "Title of an article" },
        }),
        id: "4416016600347",
      }),
      RESELLER_ID: new Article({
        name: strictLocalize({
          defaultMessage: "Do I need a reseller ID?",
          description: { text: "Title of an article" },
        }),
        id: "360016203651",
      }),
      BRICK_AND_MORTAR: new Article({
        name: strictLocalize({
          defaultMessage: "What if I don't have a brick & mortar?",
          description: { text: "Title of an article" },
        }),
        id: "360016111231",
      }),
      OPEN_WITH_FAIRE: new Article({
        name: strictLocalize({
          defaultMessage: "Opening with Faire",
          description: { text: "Title of an article" },
        }),
        id: "4645924980763",
      }),
    },
    MyOrders: {
      HOW_AM_I_NOTIFIED_NEW_ORDERS: new Article({
        name: strictLocalize({
          defaultMessage: "How am I notified of new orders?",
          description: { text: "Title of an article" },
        }),
        id: HOW_AM_I_NOTIFIED_NEW_ORDERS_ID,
      }),
      HOW_SHOULD_I_BE_SELLING_MY_FAIRE_PRODUCT: new Article({
        name: strictLocalize({
          defaultMessage: "How should I be selling my Faire products?",
          description: { text: "Title of an article" },
        }),
        id: HOW_SHOULD_I_BE_SELLING_MY_FAIRE_PRODUCTS_ID,
      }),
      BUSINESS_PROFILE: new Article({
        name: strictLocalize({
          defaultMessage: "What information is needed for my store profile?",
          description: { text: "Title of an article" },
        }),
        id: "360035578692",
      }),
      SYNC_SQUARE_POS: new Article({
        name: strictLocalize({
          defaultMessage: "Integrating my POS System with Faire",
          description: { text: "Title of an article" },
        }),
        id: "360037248712",
      }),
      FAIRE_PROTECTION: new Article({
        name: strictLocalize({
          defaultMessage: "What is Faire Protection?",
          description: { text: "Title of an article" },
        }),
        id: "360016111511",
      }),
      REPORT_DAMAGED_MISSING: new Article({
        name: strictLocalize({
          defaultMessage: "How do I report damaged or missing items?",
          description: { text: "Title of an article" },
        }),
        id: REPORT_DAMAGED_MISSING_ID,
      }),
      ORDER_STATUS: new Article({
        name: strictLocalize({
          defaultMessage: "When will I get my orders?",
          description: { text: "Title of an article" },
        }),
        id: ORDER_STATUS_ID,
      }),
      ORDER_RETURNED_TO_SENDER: new Article({
        name: strictLocalize({
          defaultMessage: "Order returned to sender",
          description: { text: "Title of an article" },
        }),
        id: "26594585812891",
      }),
      ORDER_QUESTIONS: new Article({
        name: strictLocalize({
          defaultMessage: "Questions about an item",
          description: { text: "Title of an article" },
        }),
        id: "360006953111",
      }),
      BRAND_MINIMUMS: new Article({
        name: strictLocalize({
          defaultMessage: "What are order minimums",
          description: { text: "Title of an article" },
        }),
        id: "360016302912",
      }),
      CANCELING_AN_ORDER: new Article({
        name: strictLocalize({
          defaultMessage: "How can I cancel an order?",
          description: { text: "Title of an article" },
        }),
        id: CANCELING_AN_ORDER_ID,
      }),
      CONTACT_A_BRAND: new Article({
        name: strictLocalize({
          defaultMessage: "How do I contact a brand on Faire?",
          description: { text: "Title of an article" },
        }),
        id: CONTACT_A_BRAND_ID,
      }),
    },
    ManageMyShop: {
      ADD_EDIT_PRODUCTS: new Article({
        name: strictLocalize({
          defaultMessage: "How do I add or edit products?",
          description: { text: "Title of an article" },
        }),
        id: ADD_EDIT_PRODUCTS_ID,
      }),
      CAN_I_EDIT_PRODUCTS_IN_BULK: new Article({
        name: strictLocalize({
          defaultMessage: "Can I edit products in bulk",
          description: { text: "Title of an article" },
        }),
        id: CAN_I_EDIT_PRODUCTS_IN_BULK_ID,
      }),
      HOW_DO_I_OFFER_FOOD_AND_DRINK_SAMPLES: new Article({
        name: strictLocalize({
          defaultMessage: "How do I offer food and drink samples to retailers",
          description: { text: "Title of an article" },
        }),
        id: HOW_DO_I_OFFER_FOOD_AND_DRINK_SAMPLES_ID,
      }),
      HOW_DO_I_ADD_PRODUCTS_USING_THE_BULK_UPLOADER: new Article({
        name: strictLocalize({
          defaultMessage: "How do I add products using the Bulk Uploader",
          description: { text: "Title of an article" },
        }),
        id: HOW_DO_I_ADD_PRODUCTS_USING_THE_BULK_UPLOADER_ID,
      }),
      SUBMIT_REQUEST_TO_ADD_OR_EDIT_PRODUCTS: new Article({
        name: strictLocalize({
          defaultMessage: "Submit a request to add or edit products",
          description: { text: "Title of an article" },
        }),
        id: SUBMIT_REQUEST_TO_ADD_OR_EDIT_PRODUCTS_ID,
      }),
      WILL_YOU_LIST_ALL_PRODUCTS: new Article({
        name: strictLocalize({
          defaultMessage: "Will you list all of my products",
          description: { text: "Title of an article" },
        }),
        id: WILL_YOU_LIST_ALL_PRODUCTS_ID,
      }),
      PREORDERS: new Article({
        name: strictLocalize({
          defaultMessage: "Preorders",
          description: { text: "Title of an article" },
        }),
        id: PREORDERS_ID,
      }),
      APPAREL_PREORDERS: new Article({
        name: strictLocalize({
          defaultMessage: "Apparel preorders",
          description: { text: "Title of an article" },
        }),
        id: APPAREL_PREORDERS_ID,
      }),
      WHAT_IS_PREPACK: new Article({
        name: strictLocalize({
          defaultMessage: "What is a prepack",
          description: { text: "Title of an article" },
        }),
        id: WHAT_IS_PREPACK_ID,
      }),
      OPEN_SIZING: new Article({
        name: strictLocalize({
          defaultMessage: "Open sizing",
          description: { text: "Title of an article" },
        }),
        id: OPEN_SIZING_ID,
      }),
      PRODUCT_ATTRIBUTES_AND_DETAILS: new Article({
        name: strictLocalize({
          defaultMessage: "Product attributes and details",
          description: { text: "Title of an article" },
        }),
        id: PRODUCT_ATTRIBUTES_AND_DETAILS_ID,
      }),
      BRAND_PROMOTION_CALCULATED: new Article({
        name: strictLocalize({
          defaultMessage: "How are promotions calculated?",
          description: { text: "Title of an article" },
        }),
        id: "360032489472",
      }),
      CUSTOMIZE_MY_PRODUCT_TRANSLATIONS: new Article({
        name: strictLocalize({
          defaultMessage: "Can I customize my product translations?",
          description: { text: "Title of an article" },
        }),
        id: CUSTOMIZE_MY_PRODUCT_TRANSLATIONS_ID,
      }),
      CURRENCY_SPECIFIC_PRICING: new Article({
        name: strictLocalize({
          defaultMessage: "Currency specific pricing",
          description: { text: "Title of an article" },
        }),
        id: CURRENCY_SPECIFIC_PRICING_ID,
      }),
      SETTING_PRODUCT_INVENTORY_LEVELS: new Article({
        name: strictLocalize({
          defaultMessage: "Setting my product inventory levels",
          description: { text: "Title of an article" },
        }),
        id: "360045187791",
      }),
      ARRANGE_MY_SHOP_LISTINGS: new Article({
        name: strictLocalize({
          defaultMessage: "How do I arrange my shop listings?",
          description: { text: "Title of an article" },
        }),
        id: "360039477271",
      }),
      SHOP_PERFORMANCE_ANALYTICS: new Article({
        name: strictLocalize({
          defaultMessage: "How do I view my shop’s performance analytics",
          description: { text: "Title of an article" },
        }),
        id: SHOP_PERFORMANCE_ANALYTICS_ID,
      }),
      BUILDING_POSITIVE_REPUTATION: new Article({
        name: strictLocalize({
          defaultMessage: "Building a positive reputation through reviews",
          description: { text: "Title of an article" },
        }),
        id: BUILDING_POSITIVE_REPUTATION_ID,
      }),
      WHAT_IS_EXCLUSIVITY_PROGRAM: new Article({
        name: strictLocalize({
          defaultMessage: "What is the exclusivity program?",
          description: { text: "Title of an article" },
        }),
        id: "18543447335451",
      }),
      WHAT_TO_DO_IF_NEGATIVE_REVIEW: new Article({
        name: strictLocalize({
          defaultMessage: "What to do if I get a negative brand review",
          description: { text: "Title of an article" },
        }),
        id: "360030184911",
      }),
      WHAT_ARE_BRAND_TAGS: new Article({
        name: strictLocalize({
          defaultMessage: "What are brand tags on Faire",
          description: { text: "Title of an article" },
        }),
        id: WHAT_ARE_BRAND_TAGS_ID,
      }),
      WHAT_ARE_SOCIAL_SELLERS: new Article({
        name: strictLocalize({
          defaultMessage: "What are social sellers",
          description: { text: "Title of an article" },
        }),
        id: WHAT_ARE_SOCIAL_SELLERS_ID,
      }),
      WHAT_ARE_LEAD_TIMES: new Article({
        name: strictLocalize({
          defaultMessage: "What are lead times",
          description: { text: "Title of an article" },
        }),
        id: WHAT_ARE_LEAD_TIMES_ID,
      }),
      HOW_DO_I_CLOSE_MY_SHOP: new Article({
        name: strictLocalize({
          defaultMessage: "How do I close my shop on Faire",
          description: { text: "Title of an article" },
        }),
        id: HOW_DO_I_CLOSE_MY_SHOP_ID,
      }),
    },
    Referrals: {
      CAN_I_REFER_BRANDS_TO_FAIRE: new Article({
        name: strictLocalize({
          defaultMessage: "Can I refer brands to Faire?",
          description: { text: "Title of an article" },
        }),
        id: "4404937922587",
      }),
      USE_REFERRAL_PROMOTION: new Article({
        name: strictLocalize({
          defaultMessage: "How can I use a referral promotion from a brand?",
          description: { text: "Title of an article" },
        }),
        id: "360034300092",
      }),
    },
    OptimizingMyPage: {
      HOW_OFTEN_CAN_I_UPDATE_CONTENT: new Article({
        name: strictLocalize({
          defaultMessage: "How often can I update content",
          description: { text: "Title of an article" },
        }),
        id: HOW_OFTEN_CAN_I_UPDATE_CONTENT_ID,
      }),
      FEATURE_IMAGE_GUIDELINES: new Article({
        name: strictLocalize({
          defaultMessage: "Feature image guidelines",
          description: { text: "Title of an article" },
        }),
        id: FEATURE_IMAGE_GUIDELINES_ID,
      }),
      COVER_IMAGE_GUIDELINES: new Article({
        name: strictLocalize({
          defaultMessage: "Cover image guidelines",
          description: { text: "Title of an article" },
        }),
        id: COVER_IMAGE_GUIDELINES_ID,
      }),
      PRODUCT_PHOTOGRAPHY_GUIDELINES: new Article({
        name: strictLocalize({
          defaultMessage: "Product Photography Guidelines",
          description: { text: "Title of an article" },
        }),
        id: "360016568092",
      }),
      IMAGE_SIZE_REQUIREMENTS: new Article({
        name: strictLocalize({
          defaultMessage: "Image size requirements",
          description: { text: "Title of an article" },
        }),
        id: "360032130371",
      }),
      BRAND_STORY_GUIDELINES: new Article({
        name: strictLocalize({
          defaultMessage: "Brand story guidelines",
          description: { text: "Title of an article" },
        }),
        id: BRAND_STORY_GUIDELINES_ID,
      }),
      ADD_VIDEO: new Article({
        name: strictLocalize({
          defaultMessage: "Can I add a video to my shop?",
          description: { text: "Title of an article" },
        }),
        id: "360054846452",
      }),
    },
    InvoicesAndBilling: {
      RECEIVE_ORDER_INVOICE: new Article({
        name: strictLocalize({
          defaultMessage: "Will I receive an order invoice?",
          description: { text: "Title of an article" },
        }),
        id: "4408351766171",
      }),
      PRODUCT_REPORT: new Article({
        name: strictLocalize({
          defaultMessage:
            "What if a retailer reports my products missing or damaged?",
          description: { text: "Title of an article" },
        }),
        id: "360033568051",
      }),
      PAYOUT_CALCULATED: new Article({
        name: strictLocalize({
          defaultMessage: "How is my payout calculated?",
          description: { text: "Title of an article" },
        }),
        id: PAYOUT_CALCULATED_ID,
      }),
      PAYOUT_EUROPEAN: new Article({
        name: strictLocalize({
          defaultMessage: "How do I set up payouts to a European bank account?",
          description: { text: "Title of an article" },
        }),
        id: PAYOUT_EUROPEAN_ID,
      }),
      PAYOUT_AUSTRALIAN: new Article({
        name: strictLocalize({
          defaultMessage:
            "How do I set up payouts to an Australian bank account?",
          description: { text: "Title of an article" },
        }),
        id: PAYOUT_AUSTRALIAN_ID,
      }),
      PAYOUT_CANADIAN: new Article({
        name: strictLocalize({
          defaultMessage: "Payouts for Canadian brands",
          description: { text: "Title of an article" },
        }),
        id: PAYOUT_CANADIAN_ID,
      }),
      ISSUE_WITH_MY_ORDER_PAYOUT: new Article({
        name: strictLocalize({
          defaultMessage: "Issue with my order payout",
          description: { text: "Title of an article" },
        }),
        id: ISSUE_WITH_MY_ORDER_PAYOUT_ID,
      }),
      TAX_FORM_1099: new Article({
        name: strictLocalize({
          defaultMessage: "Will I Receive a 1099-K Tax Form?",
          description: { text: "Title of an article" },
        }),
        id: TAX_FORM_1099_ID,
      }),
      SETTING_UP_PAYOUT: new Article({
        name: strictLocalize({
          defaultMessage: "Setting up your payout account",
          description: { text: "Title of an article" },
        }),
        id: SETTING_UP_PAYOUT_ID,
      }),
      TROUBLESHOOTING_WITH_ADYEN: new Article({
        name: strictLocalize({
          defaultMessage: "​​Troubleshooting with Adyen",
          description: { text: "Title of an article" },
        }),
        id: TROUBLESHOOTING_WITH_ADYEN_ID,
      }),
      PAYOUT_ISSUE: new Article({
        name: strictLocalize({
          defaultMessage: "Issue with my order payout",
          description: { text: "Title of an article" },
        }),
        id: "360006915532",
      }),
      TAX_INFORMATION: new Article({
        name: strictLocalize({
          defaultMessage: "Setting up tax information",
          description: { text: "Title of an article" },
        }),
        id: "360038950092",
      }),
      NAM_SELL_ON_FAIRE: new Article({
        name: strictLocalize({
          defaultMessage:
            "How much does it cost to sell on Faire if I’m based in North America?",
          description: { text: "Title of an article" },
        }),
        id: NAM_SELL_ON_FAIRE_ID,
      }),
      NON_NAM_SELL_ON_FAIRE: new Article({
        name: strictLocalize({
          defaultMessage:
            "How much does it cost to sell on Faire if I’m based outside of North America?",
          description: { text: "Title of an article" },
        }),
        id: NON_NAM_SELL_ON_FAIRE_ID,
      }),
    },
    Account: {
      ORDER_ISSUE: new Article({
        name: strictLocalize({
          defaultMessage: "Why can’t I see my retailer’s order in my account?",
          description: { text: "Title of an article" },
        }),
        id: "4415920212123",
      }),
      CANNOT_FIND_ORDER_NUMBER: new Article({
        name: strictLocalize({
          defaultMessage: "Why can’t I find a retailer’s order number?",
          description: { text: "Title of an article" },
        }),
        id: "4402385627163",
      }),
      NOT_OPEN: new Article({
        name: strictLocalize({
          defaultMessage: "We aren’t open yet. Can I still order?",
          description: { text: "Title of an article" },
        }),
        id: "360016111571",
      }),
      ACCOUNT_EMAIL: new Article({
        name: strictLocalize({
          defaultMessage: "Changing my login email",
          description: { text: "Title of an article" },
        }),
        id: "360016302272",
      }),
      MANAGE_TEAMS: new Article({
        name: strictLocalize({
          defaultMessage: "Set up your team on Faire",
          description: { text: "Title of an article" },
        }),
        id: "8675579278619",
      }),
      EMAIL_NOTIFICATIONS: new Article({
        name: strictLocalize({
          defaultMessage: "Can I unsubscribe from specific Faire emails?",
          description: { text: "Title of an article" },
        }),
        id: "360059197351",
      }),
      EMAIL_PREFERENCES: new Article({
        name: strictLocalize({
          defaultMessage: "Setting my Email Preferences",
          description: { text: "Title of an article" },
        }),
        id: "360057278792",
      }),
      RESETTING_PASSWORD: new Article({
        name: strictLocalize({
          defaultMessage: "Resetting my password",
          description: { text: "Title of an article" },
        }),
        id: "360019610312",
      }),
      WHAT_IS_EXCLUSIVITY: new Article({
        name: strictLocalize({
          defaultMessage: "What is exclusivity?",
          description: { text: "Title of an article" },
        }),
        id: "19903209185947",
      }),
    },
    FaireDirect: {
      ORDER_COMMISSION: new Article({
        name: strictLocalize({
          defaultMessage: "My Direct order has commission, what happened?",
          description: { text: "Title of an article" },
        }),
        id: "360031800672",
      }),
      ZERO_COMMISSION: new Article({
        name: strictLocalize({
          defaultMessage: "Faire Direct Policy for 0% Commission",
          description: { text: "Title of an article" },
        }),
        id: "360031800672",
      }),
      EMAIL_CAMPAIGN: new Article({
        name: strictLocalize({
          defaultMessage: "What is an Email Campaign?",
          description: { text: "Title of an article" },
        }),
        id: "360038731612",
      }),
      EMAIL_AUTOMATIONS: new Article({
        name: strictLocalize({
          defaultMessage: "What are Email Automations?",
          description: { text: "Title of an article" },
        }),
        id: "360034668751",
      }),
      FAIRE_DIRECT: new Article({
        name: strictLocalize({
          defaultMessage: "What is Faire Direct?",
          description: { text: "Title of an article" },
        }),
        id: "360032132391",
      }),
      FD_ELIGIBLE: new Article({
        name: strictLocalize({
          defaultMessage: "Who is eligible to order via Faire Direct?",
          description: { text: "Title of an article" },
        }),
        id: "360032149291",
      }),
      FD_LINK: new Article({
        name: "How do I use my Direct Link?",
        id: "360032133351",
      }),
      WIDGET_GENERAL: new Article({
        name: strictLocalize({
          defaultMessage: "What is the Faire Direct widget?",
          description: {
            text: "Title of an article",
            img: "https://cdn.faire.com/fastly/a6a14152fd5623c230ffba52dff61bbb1683269c5c15f68b6e55798c1d3b275e.png",
          },
        }),
        id: "360040031351",
      }),
      WIDGET_SHOPIFY: new Article({
        name: strictLocalize({
          defaultMessage: "How to embed your Faire Direct widget on Shopify",
          description: {
            text: "Title of an article",
            img: "https://cdn.faire.com/fastly/a6a14152fd5623c230ffba52dff61bbb1683269c5c15f68b6e55798c1d3b275e.png",
          },
        }),
        id: "10268063927579",
      }),
      WIDGET_WOOCOMMERCE: new Article({
        name: strictLocalize({
          defaultMessage:
            "How to embed your Faire Direct widget on WooCommerce",
          description: {
            text: "Title of an article",
            img: "https://cdn.faire.com/fastly/a6a14152fd5623c230ffba52dff61bbb1683269c5c15f68b6e55798c1d3b275e.png",
          },
        }),
        id: "24153780884763",
      }),
      WIDGET_PRESTASHOP: new Article({
        name: strictLocalize({
          defaultMessage: "How to embed your Faire Direct widget on Prestashop",
          description: {
            text: "Title of an article",
            img: "https://cdn.faire.com/fastly/a6a14152fd5623c230ffba52dff61bbb1683269c5c15f68b6e55798c1d3b275e.png",
          },
        }),
        id: "25144215925787",
      }),
    },
    FulfillingOrders: {
      SPLIT_ATS_ORDER: new Article({
        name: strictLocalize({
          defaultMessage: "How to split an ATS order",
          description: { text: "Title of an article" },
        }),
        id: "360060488431",
      }),
      SPLIT_PREORDER: new Article({
        name: strictLocalize({
          defaultMessage: "How to split a preorder",
          description: { text: "Title of an article" },
        }),
        id: "360060414111",
      }),
      ACCEPTING_ORDER: new Article({
        name: strictLocalize({
          defaultMessage: "Accepting an order",
          description: { text: "Title of an article" },
        }),
        id: ACCEPTING_ORDER_ID,
      }),
      COMMERCIAL_INVOICE: new Article({
        name: strictLocalize({
          defaultMessage: "How do I create a commercial invoice",
          description: { text: "Title of an article" },
        }),
        id: "4404314652059",
      }),
      FULFILLING_ORDER: new Article({
        name: strictLocalize({
          defaultMessage: "I can't fulfill an order",
          description: { text: "Title of an article" },
        }),
        id: "360007184831",
      }),
      UNDERSTAND_ORDER_STATUS: new Article({
        name: strictLocalize({
          defaultMessage: "Understanding your order's status",
          description: { text: "Title of an article" },
        }),
        id: ORDER_INVOICE_ID,
      }),
      CAN_RETAILER_CANCEL_ORDER: new Article({
        name: strictLocalize({
          defaultMessage: "Can a retailer cancel their order?",
          description: { text: "Title of an article" },
        }),
        id: "360023102031",
      }),
      SHIPPING_ORDER: new Article({
        name: strictLocalize({
          defaultMessage: "Shipping an order",
          description: { text: "Title of an article" },
        }),
        id: "360023300451",
      }),
      SETTING_OUT_OF_STOCK: new Article({
        name: strictLocalize({
          defaultMessage: "Setting out-of-stock or discontinued items",
          description: { text: "Title of an article" },
        }),
        id: "360006911352",
      }),
      SHIP_WITH_FAIRE: new Article({
        name: strictLocalize({
          defaultMessage: "Ship with Faire",
          description: { text: "Title of an article" },
        }),
        id: "360030933131",
      }),
      LABEL_ISSUES: new Article({
        name: strictLocalize({
          defaultMessage:
            "Why am I getting an error when using Ship with Faire",
          description: { text: "Title of an article" },
        }),
        id: "360040920571",
      }),
      SHIP_ON_YOUR_OWN: new Article({
        name: strictLocalize({
          defaultMessage: "How to ship orders on your own",
          description: { text: "Title of an article" },
        }),
        id: "360030933311",
      }),

      SHIPPING_COSTS: new Article({
        name: strictLocalize({
          defaultMessage: "Managing shipping costs to other countries",
          description: { text: "Title of an article" },
        }),
        id: "360040349352",
      }),

      SHIPPING_WORK: new Article({
        name: strictLocalize({
          defaultMessage: "How does shipping work?",
          description: { text: "Title of an article" },
        }),
        id: "4405859125531",
      }),
      ABOUT_SHIPPING: new Article({
        name: strictLocalize({
          defaultMessage: "What about shipping?",
          description: { text: "Title of an article" },
        }),
        id: "360016111831",
      }),
      SHIPPING_ADDRESS: new Article({
        name: strictLocalize({
          defaultMessage: "How do I change my shipping address",
          description: { text: "Title of an article" },
        }),
        id: "360018235292",
      }),
      CHANGE_SHIPPING_ADDRESS: new Article({
        name: strictLocalize({
          defaultMessage: "Can I change my address after order shipped?",
          description: { text: "Title of an article" },
        }),
        id: "360007197951",
      }),
      EDIT_RETAILER_ORDER: new Article({
        name: strictLocalize({
          defaultMessage: "Can I edit a retailer’s order",
          description: { text: "Title of an article" },
        }),
        id: "360053212551",
      }),
      FULFILLING_SCHEDULED_ORDERS: new Article({
        name: strictLocalize({
          defaultMessage: "Fulfilling scheduled orders",
          description: { text: "Title of an article" },
        }),
        id: FULFILLING_SCHEDULED_ORDERS_ID,
      }),
      SELLING_AND_IMPORTING_PRODUCTS_INTO_EU: new Article({
        name: strictLocalize({
          defaultMessage: "Selling and importing your products into the EU",
          description: { text: "Title of an article" },
        }),
        id: SELLING_AND_IMPORTING_PRODUCTS_INTO_EU_ID,
      }),
    },
    ReturnsAndRefunds: {
      MAKE_A_RETURN: new Article({
        name: strictLocalize({
          defaultMessage: "How do I submit a return?",
          description: { text: "Title of an article" },
        }),
        id: MAKE_A_RETURN_ID,
      }),
      EXTEND_A_RETURN: new Article({
        name: strictLocalize({
          defaultMessage: "Can I extend my return window?",
          description: { text: "Title of an article" },
        }),
        id: "360022876131",
      }),
      CANT_RETURN: new Article({
        name: strictLocalize({
          defaultMessage: "Why can’t I return my items?",
          description: { text: "Title of an article" },
        }),
        id: "360007069352",
      }),
    },
    PaymentsAndInvoices: {
      CHANGE_MY_PAYMENT_METHOD: new Article({
        name: strictLocalize({
          defaultMessage: "Changing my payment method",
          description: { text: "Title of an article" },
        }),
        id: "360018497831",
      }),
      NET_60_TERMS: new Article({
        name: strictLocalize({
          defaultMessage: "How do net 60 terms work?",
          description: { text: "Title of an article" },
        }),
        id: HOW_DO_NET_60_TERMS_WORK_ID,
      }),
      PAY_INVOICES: new Article({
        name: strictLocalize({
          defaultMessage: "How do I pay my invoices?",
          description: { text: "Title of an article" },
        }),
        id: "360006920172",
      }),
      INVOICE_DUE: new Article({
        name: strictLocalize({
          defaultMessage: "When is my invoice due?",
          description: { text: "Title of an article" },
        }),
        id: "360006994232",
      }),
      UNDERSTANDING_ORDER_INVOICE: new Article({
        name: strictLocalize({
          defaultMessage: "Understanding the order Invoice",
          description: { text: "Title of an article" },
        }),
        id: "4416125712795",
      }),
      HOW_DO_I_PAY_FOR_ORDERS: new Article({
        name: strictLocalize({
          defaultMessage: "How do I pay for orders?",
          description: { text: "Title of an article" },
        }),
        id: "360015892632",
      }),
      HOW_DO_I_CHANGE_MY_BILLING_ADDRESS: new Article({
        name: strictLocalize({
          defaultMessage: "How do I change my billing address?",
          description: { text: "Title of an article" },
        }),
        id: "24430827309467",
      }),
    },
    INSIDER: {
      INSIDER_BRAND_PARTNERSHIP: new Article({
        name: strictLocalize({
          defaultMessage: "The Insider Partnership for brands",
          description: { text: "Title of an article" },
        }),
        id: "25213101060123",
      }),
    },
    FAQ: {
      RESETTING_PASSWORD: new Article({
        name: strictLocalize({
          defaultMessage: "Resetting my password",
          description: { text: "Title of an article" },
        }),
        id: "360019854651",
      }),
      RETAILER_WHAT_IS_FAIRE: new Article({
        name: strictLocalize({
          defaultMessage: "How do I start buying on Faire?",
          description: { text: "Title of an article" },
        }),
        id: RETAILER_WHAT_IS_FAIRE_ID,
      }),
      EU_DSA: new Article({
        name: strictLocalize({
          defaultMessage: "EU Digital Services Act Single Point of Contact",
          description: {
            text: "Title of an article",
            img: "https://cdn.faire.com/fastly/a0fc393cb747e066d1dc763daeb1315f302a416838efda41d53f5e369a07dec5.png",
          },
        }),
        id: EU_DSA_ID,
      }),
      HOW_RETURNS_WORK: new Article({
        name: strictLocalize({
          defaultMessage: "How do returns work",
          description: { text: "Title of an article" },
        }),
        id: "360015892592",
      }),
      FAIRE_INSIDER_US: new Article({
        name: strictLocalize({
          defaultMessage: "How does Insider for US retailers work?",
          description: { text: "Title of an article" },
        }),
        id: "4406840862747",
      }),
      FAIRE_INSIDER_EU: new Article({
        name: strictLocalize({
          defaultMessage: "How does Insider work for European retailers?",
          description: { text: "Title of an article" },
        }),
        id: "4418050425115",
      }),
      WHERE_IS_FAIRE_AVAILABLE: new Article({
        name: strictLocalize({
          defaultMessage: "Where is Faire available?",
          description: { text: "Title of an article" },
        }),
        id: WHERE_IS_FAIRE_AVAILABLE_ID,
      }),
      BRAND_REFERRAL_PROGRAM_TERMS_CONDITIONS: new Article({
        name: strictLocalize({
          defaultMessage: "FAIRE BRAND REFERRAL PROGRAM TERMS & CONDITIONS",
          description: { text: "Title of an article" },
        }),
        id: "13628687993371",
      }),
      FAIRE_ACCOUNT_SECURITY: new Article({
        name: strictLocalize({
          defaultMessage: "Faire account security best practices",
          description: { text: "Title of an article" },
        }),
        id: FAIRE_ACCOUNT_SECURITY_ID,
      }),
    },
    FAQForProspectiveBrands: {
      HOW_GET_PAID: new Article({
        name: strictLocalize({
          defaultMessage: "How do I get paid?",
          description: { text: "Title of an article" },
        }),
        id: "360015893272",
      }),
      FAIRE_COST: new Article({
        name: strictLocalize({
          defaultMessage: "How much does it cost to sell on Faire?",
          description: { text: "Title of an article" },
        }),
        id: FAIRE_COST_ID,
      }),
      BECOME_BRAND: new Article({
        name: strictLocalize({
          defaultMessage: "How do I sell on Faire?",
          description: { text: "Title of an article" },
        }),
        id: BECOME_BRAND_ID,
      }),
    },
    International: {
      VAT_WORK_NON_EU_ORDERS: new Article({
        name: strictLocalize({
          defaultMessage: "How does VAT work for Non-E.U. European orders?",
          description: { text: "Title of an article" },
        }),
        id: "4404431808155",
      }),
      PAY_VAT_NON_EU: new Article({
        name: strictLocalize({
          defaultMessage:
            "How will I pay VAT on my orders in Non-EU European countries?",
          description: { text: "Title of an article" },
        }),
        id: "4404431878683",
      }),
      VAT_WORK_EU_ORDERS: new Article({
        name: strictLocalize({
          defaultMessage: "How does VAT work for E.U. orders?",
          description: { text: "Title of an article" },
        }),
        id: "360057747911",
      }),
      CANADIAN_RETAILERS: new Article({
        name: strictLocalize({
          defaultMessage: "Getting started as a Canadian retailer",
          description: { text: "Title of an article" },
        }),
        id: "360034894292",
      }),
      LOCATION_SHOP_LIVE: new Article({
        name: strictLocalize({
          defaultMessage: "Can I control the locations where my shop is live?",
          description: { text: "Title of an article" },
        }),
        id: LOCATION_SHOP_LIVE_ID,
      }),
      SELLING: new Article({
        name: strictLocalize({
          defaultMessage: "A guide to selling internationally on Faire",
          description: { text: "Title of an article" },
        }),
        id: "4407511671579",
      }),
      BUY: new Article({
        name: strictLocalize({
          defaultMessage: "How to buy internationally on Faire",
          description: { text: "Title of an article" },
        }),
        id: "4405345083675",
      }),
    },
    ContactMyRetailer: {
      CONTACTING_MY_RETAILER: new Article({
        name: strictLocalize({
          defaultMessage: "How do I contact my retailers on Faire?",
          description: { text: "Title of an article" },
        }),
        id: CONTACTING_MY_RETAILER_ID,
      }),
    },

    BrandTermsAndPolicies: {
      DISPUTE_A_RETAILER_COMPLAINT: new Article({
        name: strictLocalize({
          defaultMessage: "Dispute a retailer complaint",
          description: { text: "Title of an article" },
        }),
        id: DISPUTE_A_RETAILER_COMPLAINT_ID,
      }),
      BRAND_POLICIES: new Article({
        name: strictLocalize({
          defaultMessage: "Brand policies",
          description: { text: "Title of an article" },
        }),
        id: BRAND_POLICIES_ID,
      }),
    },

    ImportFeesAndDuties: {
      DUTIES_REFUND: new Article({
        name: strictLocalize({
          defaultMessage: "What happens when Faire covers my import duties?",
          description: { text: "Title of an article" },
        }),
        id: "4403349101723",
      }),
      USA: new Article({
        name: strictLocalize({
          defaultMessage: "How does shipping into the US work?",
          description: { text: "Title of an article" },
        }),
        id: "360031133351",
      }),
      Canada: new Article({
        name: strictLocalize({
          defaultMessage: "How does shipping into Canada work?",
          description: { text: "Title of an article" },
        }),
        id: "360057607832",
      }),
      Europe: new Article({
        name: strictLocalize({
          defaultMessage: "Importing to Europe",
          description: { text: "Title of an article" },
        }),
        id: "360056061932",
      }),
      Australia: new Article({
        name: strictLocalize({
          defaultMessage: "Importing to Australia",
          description: { text: "Title of an article" },
        }),
        id: "6668590967579",
      }),
      EORI: new Article({
        name: strictLocalize({
          defaultMessage: "How do I apply for an EORI number?",
          description: { text: "Title of an article" },
        }),
        id: "4409464460187",
      }),
      VAT: new Article({
        name: strictLocalize({
          defaultMessage: "Do I need a VAT number?",
          description: { text: "Title of an article" },
        }),
        id: "4405333889435",
      }),
    },
    Integration: {
      SOFTWARE_INTEGRATION_WITH_FAIRE: new Article({
        name: strictLocalize({
          defaultMessage: "Software integration with Faire",
          description: { text: "Title of an article" },
        }),
        id: SOFTWARE_INTEGRATION_WITH_FAIRE_ID,
      }),
      MANAGING_INTEGRATIONS_ON_FAIRE: new Article({
        name: strictLocalize({
          defaultMessage: "Managing Integrations on Faire",
          description: { text: "Title of an article" },
        }),
        id: "4409994540571",
      }),
      ONBOARDING_WITH_SHOPIFY: new Article({
        name: strictLocalize({
          defaultMessage: "Onboarding with Shopify",
          description: { text: "Title of an article" },
        }),
        id: "4407533398939",
      }),
      CAN_I_INTEGRATE_WITH_SHOPIFY: new Article({
        name: strictLocalize({
          defaultMessage: "Can I integrate with Shopify",
          description: { text: "Title of an article" },
        }),
        id: CAN_I_INTEGRATE_WITH_SHOPIFY_ID,
      }),
      HOW_DOES_SHOPIFY_PRICE_SYNC_WORK: new Article({
        name: strictLocalize({
          defaultMessage: "How does Shopify price sync work",
          description: { text: "Title of an article" },
        }),
        id: HOW_DOES_SHOPIFY_PRICE_SYNC_WORK_ID,
      }),
      PRESTASHOP_INTEGRATION_WITH_FAIRE: new Article({
        name: strictLocalize({
          defaultMessage: "PrestaShop Integration with Faire",
          description: { text: "Title of an article" },
        }),
        id: PRESTASHOP_INTEGRATION_WITH_FAIRE_ID,
      }),
      WOOCOMMERCE_INTEGRATION_WITH_FAIRE: new Article({
        name: strictLocalize({
          defaultMessage: "WooCommerce Integration with Faire",
          description: { text: "Title of an article" },
        }),
        id: WOOCOMMERCE_INTEGRATION_WITH_FAIRE_ID,
      }),
    },
  };
  return articles;
};
